import { useEffect, useState } from 'react';
import { ensureCsrfToken, getCsrfToken } from '../api/request';

type CsrfHeaders = Record<string, string>;

/**
 * Prepare CSRF headers for upload components.
 */
export function useCsrfHeaders() {
  const [headers, setHeaders] = useState<CsrfHeaders>({});

  useEffect(() => {
    let active = true;

    const load = async () => {
      const token = await ensureCsrfToken();
      if (!active) {
        return;
      }
      const resolvedToken = token || getCsrfToken();
      setHeaders(resolvedToken ? { 'X-CSRF-Token': resolvedToken } : {});
    };

    load().catch(() => {
      if (active) {
        setHeaders({});
      }
    });

    return () => {
      active = false;
    };
  }, []);

  return headers;
}
